import { PracticeDetailFields } from '@cibo/core'
import { ResponsiveDialog } from '@cibo/ui'
import {
  Box,
  Checkbox,
  DialogActions,
  DialogContent,
  FormControlLabel,
  Stack,
  Typography,
} from '@mui/material'
import Button from '@mui/material/Button'
import { ChangeEvent, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { PracticeRequirementModalState } from './PracticeRequirementModalTypes'

type PracticeRequirementModalProps = {
  modalState: PracticeRequirementModalState
  setModalState: (state: PracticeRequirementModalState) => void
  onClickSelect: (practiceId?: string) => void
}

export const PracticeRequirementModal = ({
  onClickSelect,
  modalState,
  setModalState,
}: PracticeRequirementModalProps) => {
  const { t } = useTranslation('@cibo/programs/PracticesList')

  const [isChecked, setIsChecked] = useState(false)

  const handleCloseDialog = () => {
    setIsChecked(false)
    setModalState({ open: false, practice: undefined, onClickSelect: modalState.onClickSelect })
  }
  const handleCheckBox = (event: ChangeEvent<HTMLInputElement>) => {
    setIsChecked(event.target.checked)
  }

  return (
    <ResponsiveDialog
      open={modalState.open}
      onClose={handleCloseDialog}
      sx={{
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
      }}
    >
      <DialogContent>
        <Stack spacing={3}>
          <Typography variant="h6" component="h2" data-testid="dialog-title">
            {t('dialogTitle')}
          </Typography>
          <Typography variant="body1" color="text.secondary">
            {t('dialogSubtitle')}
          </Typography>
          <Box
            padding={1.5}
            sx={{
              backgroundColor: 'background.default',
              overflowY: 'auto',
            }}
          >
            <Typography variant="body1">
              {(modalState.practice?.fields as unknown as PracticeDetailFields)?.requirementText}
            </Typography>
          </Box>
          <FormControlLabel
            data-testid="confirmCheckbox"
            control={
              <Checkbox checked={isChecked} onChange={handleCheckBox} name="confirmCheckbox" />
            }
            label={t('confirmCheckboxLabel')}
          />
          <DialogActions>
            <Stack spacing={3} direction="row">
              <Button color="secondary" onClick={handleCloseDialog}>
                {t('cancel')}
              </Button>
              <Button
                color="primary"
                data-testid="addPracticeModelBtn"
                onClick={() => {
                  modalState.practice?.fields?.practiceId &&
                    onClickSelect(modalState.practice?.fields?.practiceId)
                  handleCloseDialog()
                }}
                variant="contained"
                disabled={!isChecked}
              >
                {t('addPractice')}
              </Button>
            </Stack>
          </DialogActions>
        </Stack>
      </DialogContent>
    </ResponsiveDialog>
  )
}
